import { createContext, useContext } from 'react';

import type { INotificationContext, INotificationsContext } from './Notifications.models';

export const NotificationsContext = createContext<INotificationsContext>({
  notifications: [],
  add: () => {},
  success: () => {},
  error: () => {},
  remove: () => {},
  removeAll: () => {},
});

export const useNotificationsContext = () => {
  return useContext(NotificationsContext);
};

export const NotificationContext = createContext<INotificationContext>({
  close: () => {},
});
